import React from 'react';
import { Route, Redirect } from 'react-router-dom';

function PrivateRoute({ component: C, ...rest }) { 
  return (
    <Route {...rest} render={props => localStorage.getItem('user') ? (<C {...props} {...rest} />) : 
    (<Redirect to={{ pathname: "/login", state: { referer: props.location } }}/> ) }/>)
}

export default PrivateRoute;

